"use client";
import { ImageType } from "../../../types/baseTypes";
import styles from "./TextGraphic.module.scss";
import { MediaItem } from "@/components/Global/MediaItem/MediaItem.tsx";
import sanitizeHtml from "sanitize-html";

interface FooterTextGraphicProps {
  svg: ImageType;
  content: string;
}

export const TextGraphic = ({ svg, content }: FooterTextGraphicProps) => {
  return (
    <div className={`${styles["footer-text-graphic"]}`}>
      <MediaItem
        className={styles["topfi-image"]}
        image_desktop={svg}
        sizes={"50vw"}
      />
      <div
        className={`${styles["speech-bubble"]}`}
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }}
      />
    </div>
  );
};
